module.exports = __webpack_public_path__ + "static/img/img2.8453bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/BSP_Sequencing/img2.png
// module id = v79d
// module chunks = 16